import type { CompressionOptions } from '@/components/projects/interfaces.ts'

export const IMAGE_ALLOWED_TYPES: string[] = ['image/jpeg', 'image/png', 'image/webp', 'image/heic']
export const FILE_PROCESS_DEBOUNCE_MS = 300

export function getCompressionImageOptions(): Omit<CompressionOptions, 'signal' | 'onProgress'> {
  return {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 128,
    useWebWorker: true,
    fileType: 'image/webp',
    initialQuality: 0.8,
  }
}

export function validateFileTypeAndSize(file: File) {
  const MAX_SIZE = 10 * 1024 * 1024 // 10MB

  if (!IMAGE_ALLOWED_TYPES.includes(file.type)) {
    throw new Error('Invalid file type')
  }
  if (file.size > MAX_SIZE) {
    throw new Error('File too large')
  }
}
